import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  msteamDeauthorize,
  teamsRedirect,
  teamsClientId,
} from '../../services';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIntegrationAvailable,
  setIntegrationData,
} from '../../redux/slices/integrationsSlice';
import {
  selectMsteamsAvailable,
  selectMsteamsInstances,
} from '../../redux/selectors/integrationsSelectors';
import {
  selectAuthToken,
  selectAuthIsTeamOwner,
} from '../../redux/selectors/authSelectors';

const MSTeamIntegration = () => {
  const tenant = 'common';
  const redirect = teamsRedirect();
  const client_id = teamsClientId();
  const dispatch = useDispatch();
  const token = useSelector(selectAuthToken);
  const isTeamOwner = useSelector(selectAuthIsTeamOwner);
  const msteamAvailable = useSelector(selectMsteamsAvailable);
  const msTeamInstances = useSelector(selectMsteamsInstances);
  const [msTeamUrl, setMSTeamUrl] = useState(null);

  useEffect(() => {
    setMSTeamUrl(
      `https://login.microsoftonline.com/${tenant}/adminconsent?client_id=${client_id}&state=${token}&redirect_uri=${redirect}`
    );
  }, [token]);

  const handleDeauthClick = (e) => {
    e.preventDefault();
    msteamDeauthorize(token).then((status) => {
      if (status) {
        toast.success('Success: MSTeams account has been deauthorized', {
          position: 'top-right',
          autoClose: 4000,
        });
        dispatch(
          setIntegrationData({
            id: 'msteams',
            data: { channels: [], instances: [] },
          })
        );
        dispatch(
          setIntegrationAvailable({ id: 'msteams', available: false })
        );
      } else {
        toast.error('Error: There was a problem deauthorizing MSTeams.', {
          position: 'top-right',
          autoClose: 4000,
        });
      }
    });
  };

  let msTeamsButton = '';
  if (isTeamOwner && msTeamUrl) {
    msTeamsButton =
      msteamAvailable && msTeamInstances?.length ? (
        <>
          <Card.Header as='h5' className='cstm-card-title'>
            Microsoft Teams Configuration
          </Card.Header>
          <Card.Body>
            <Card.Title>Teams Channel Configuration</Card.Title>
            <Card.Text>
              Update which channel(s) you want to allow notifications to.
            </Card.Text>
            <a
              className='add_to_slack_btn'
              href='#/config/msteams'
              role='button'
            >
              Update Channel Selection
            </a>
            <Card.Text style={{ marginTop: '20px' }}>
              Need to unplug Teams or reauthorize to a different account?
            </Card.Text>
            <a
              href='#deauthorize-msteams'
              className='add_to_slack_btn gray_btn'
              onClick={(e) => handleDeauthClick(e)}
              role='button'
            >
              Deauthorize Teams
            </a>
          </Card.Body>
        </>
      ) : (
        <>
          <Card.Header as='h5'>Microsoft Teams Configuration</Card.Header>
          <Card.Body>
            <Card.Title>
              Click the below button to authorize Security Bulldog to push
              document shares and other messages to any of MS Teams Channels you
              choose. You will need be able to log into your MS Teams workspace
              and be authorized to add apps.
            </Card.Title>
            <Card.Text>
              Once Teams is authorized you will redirect back to Security
              Bulldog to select the Teams Channels you would like messages
              delivered to.
            </Card.Text>
            <a className='add_to_slack_btn' href={msTeamUrl}>
              Authorize Teams
            </a>
          </Card.Body>
        </>
      );
  }

  return (
    <Container>
      <Row>
        <Col lg={12}>
          <div className='mt-4 add_to_slack_wrap'>
            <Card>{msTeamsButton}</Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MSTeamIntegration;
